import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/zh-cn/services/software-solutions-services/ai-ml-compliance")({
  head: () => buildRouteHead("/zh-cn/services/software-solutions-services/ai-ml-compliance"),
  component: SWOffering,
});

